module.exports = __webpack_public_path__ + "img/n.801a6af5.jpg";